import { render, staticRenderFns } from "./SizeInput.vue?vue&type=template&id=38d076de&scoped=true&"
import script from "./SizeInput.vue?vue&type=script&lang=ts&"
export * from "./SizeInput.vue?vue&type=script&lang=ts&"
import style0 from "./SizeInput.vue?vue&type=style&index=0&id=38d076de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d076de",
  null
  
)

export default component.exports